export const StyledVars = {
    media: {
        big:  '(max-width: 1200px)',
        middle: '(max-width: 1100px)',
        small: '(max-width: 800px)',
        some: '(max-width: 1000px) and (min-width: 600px)',
        textSize: '(max-width: 600px)',
    }
}
